import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({
    selector: '[onlyAlphabets]',
    standalone: false
})
export class OnlyAlphabetsDirective {
    @HostBinding('attr.autocomplete') public autocomplete;

    constructor() {
        this.autocomplete = 'off';
    }

    @HostListener('keypress', ['$event']) public disableKeys(e) {
        const keyCode = e.keyCode;
        return (keyCode === 8 || (keyCode >= 97 && keyCode <= 122) || (keyCode >= 65 && keyCode <= 90));
    }
}
